module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/vegamagic.d6a48b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/vegamagic.jpg
// module id = d8jH
// module chunks = 0